var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowcurveleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450.591,
    height: 367.145,
    viewBox: "0 0 450.591 367.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-arrow-4760095",
    d: "M302.651,168.95h100.38A172.264,172.264,0,0,1,575.3,341.22V445.7a6.824,6.824,0,0,1-.387,2.8,17.487,17.487,0,0,1-34.4-.875l-.035-.035a8.609,8.609,0,0,1-.176-1.891v-.77a137.3,137.3,0,0,0-137.27-137.27H295.3V360.79c0,16.871-16.273,26.074-29.262,13.125l-135.38-119.35a17.474,17.474,0,0,1-.141-26.145l140-125.65c16.1-14.453,32.129-6.547,32.129,11.551v54.637Z",
    transform: "translate(-124.71 -95.286)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcurveleft);
export default __webpack_public_path__ + "static/media/arrow curve left.fbb0982fe4e2dbbd46acc7788d425a0d.svg";
export { ForwardRef as ReactComponent };